import { configureStore, combineReducers } from '@reduxjs/toolkit'
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from 'redux-persist'
import storage from 'redux-persist/lib/storage' // 默认使用 localStorage
import userMenuSlice from './user/userMenu'
import userInfo from './user/userInfo'

// 只针对 user 的持久化配置 

const rootReducer = combineReducers({
  menu: userMenuSlice,
  user: userInfo,
})
const persistConfig = {
  key: 'root', // 存储在 localStorage 中的键名
  storage, // 使用的存储引擎
  whitelist: ['user', 'menu', 'socket'] // 明确声明只持久化 'user' 这个 reducer 的状态
}
// 只对 user reducer 进行持久化 :cite[5]
const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // 忽略 redux-persist 的特定 action 类型
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

// 创建持久化器
export const persistor = persistStore(store)

// 从 store 推导类型
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch